import React from 'react';
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useMutation } from 'react-query';
import rootApi from '@utils/baseAPI/WrapperApi';
import { showError, showSuccess } from '@components/notification';

const DialogUnbindTariff = ({ depot, open, setOpen, refetch }) => {
  const tariffBinds = depot?.tariff_binds || [];

  const { mutate, isLoading, variables: removingId } = useMutation(
    (tariffId) =>
      rootApi.post('/tariff-depots/unbind', {
        depot_codes: [depot?.depot_code],
        tariff_id: tariffId
      }),
    {
      onSuccess: (_, tariffId) => {
        showSuccess({ message: 'Gỡ gói giá thành công' });
        refetch();
      },
      onError: () => showError('Gỡ thất bại. Vui lòng thử lại.')
    }
  );

  const handleClose = () => setOpen(false);

  const handleRemove = (tariff) => {
    if (window.confirm(`Gỡ gói giá "${tariff.name}" khỏi trạm "${depot?.depot_code}"?`)) {
      mutate(tariff.id);
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography variant="h6" fontWeight={700}>
          Gỡ gói giá sạc
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          Trạm: <strong>{depot?.depot_code}</strong> — {depot?.depot_name}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {tariffBinds.length === 0 ? (
          <Typography color="text.secondary" sx={{ textAlign: 'center', py: 3 }}>
            Trạm này chưa được gán gói giá nào.
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 700, fontSize: '0.78rem' }}>Tên gói giá</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: '0.78rem' }}>Đang hoạt động</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: '0.78rem', width: 60 }}>Gỡ</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tariffBinds.map((tariff) => {
                const isActive = depot?.tariff_active?.id === tariff.id;
                const removing = isLoading && removingId === tariff.id;
                return (
                  <TableRow key={tariff.id}>
                    <TableCell>
                      <Typography variant="body2" fontWeight={isActive ? 700 : 400}>
                        {tariff.name}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {isActive && (
                        <Chip
                          label="Đang hoạt động"
                          size="small"
                          color="success"
                          sx={{ fontSize: '0.68rem', height: 20 }}
                        />
                      )}
                    </TableCell>
                    <TableCell>
                      <Tooltip title="Gỡ gói giá này">
                        <span>
                          <IconButton
                            size="small"
                            color="error"
                            disabled={isLoading}
                            onClick={() => handleRemove(tariff)}>
                            {removing ? <CircularProgress size={16} /> : <Delete fontSize="small" />}
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}

        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button variant="outlined" onClick={handleClose}>Đóng</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DialogUnbindTariff;
